import { createOfferContract } from '../oc-offers-widget/shared/contract-factory.js';
import themes from './themes/index.js';
import { createDehydratedState } from './state.js';

const baseContract = createOfferContract(
  'offers-slim',
  themes,
  createDehydratedState
);

export const contract = async (campaignData, el) => {
  const props = await baseContract(campaignData, el);

  if (!props) {
    return null;
  }

  // Add variant prop based on autohide-terms attribute or autohideTerms data property
  const hasAutohideTermsAttr = el.hasAttribute('autohide-terms');
  const hasAutohideTermsData = campaignData?.autohideTerms === true;
  const variant =
    hasAutohideTermsAttr || hasAutohideTermsData ? 'autohide' : 'default';

  return {
    ...props,
    variant
  };
};
